import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiceService } from '../service.service';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sales-team-creation',
  templateUrl: './sales-team-creation.component.html',
  styleUrls: ['./sales-team-creation.component.css']
})
export class SalesTeamCreationComponent implements OnInit {

  constructor(private brandService:ServiceService,private router: Router) { }

  public model = Array();
  dropdownList:any = [];
  options:any=[];
  selectedItems:any = [];
  minDate= new Date()
  maxDate= new Date()
  calenderShown=false
  output:any=[]; //---store get() result--------
  BName="*"
  MName="*"
  TeamName="*"
  MgrName="*"
  TeamMates="*"

  searchEmployee:string='';
  Search_employee=""
  isShownEmployee=false;
  employee:any=[];

  // 🎯 NEW: Add year selection property
  selectedYear: number = new Date().getFullYear();
  availableYears: number[] = [2024, 2025, 2026]; // You can extend this as needed

  dropdownSettings = {
    singleSelection: false,
    idField: 'item_id',
    textField: 'item_text',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true
  };

  data:any={
    brand_id:null,
    brand_name:null,
    brand_manager_id:null,
    brand_manager_name:"",
    team_name:null,
    month:"",
    team_mates:[],
    working_days:[]
  }
  isShown: boolean = false;
  alert=""
  message=""
  Brand:any=[];

  Month=[{name:"January",id:"01",last:31},
         {name:"February",id:"02",last:28},
         {name:"March",id:"03",last:31},
         {name:"April",id:"04",last:30},
         {name:"May",id:"05",last:31},
         {name:"June",id:"06",last:30},
         {name:"July",id:"07",last:31},
         {name:"August",id:"08",last:31},
         {name:"September",id:"09",last:30},
         {name:"October",id:"10",last:31},
         {name:"November",id:"11",last:30},
         {name:"December",id:"12",last:31},
        ]

  shown(){
    this.isShown=false
  }
  
  notification(){
    this.isShown = !this.isShown;
  }
 
  ChangeForm(){
    this.data.working_days=[];
    for(var i=0;i<this.model.length;i++){
      var d = new Date(this.model[i]);
      var timeZoneDifference = (d.getTimezoneOffset() / 60) * -1; //convert to positive value.
      d.setTime(d.getTime() + (timeZoneDifference * 60) * 60 * 1000);
      d.toISOString()
      this.data.working_days.push(d)
    }
  }

  //---------function for edit brand detail-----
  btnClick()
  {
    this.SetFinalTeam();
    this.ChangeForm();

    let check=false
    console.log("Data=",this.data)

    if(this.data.month==""){
      this.MName="select a month"
      check=true
    }

    if(this.data.brand_manager_name==""){
      this.MgrName="select a Manager"
      check=true
    }
    if(this.data.team_name==null){
      this.TeamName="Enter a team name"
      check=true
    }
    if(this.data.team_mates.length==0){
      this.TeamMates="Select team members"
      check=true
    }

    if(check==true){
      return
    }

    // --------api for put----------//
    this.brandService.SalesTeam(this.data).subscribe((res) => {
      this.alert=res.message;
      console.log("res=",res);
      
      // ✅ USE TOAST MESSAGE INSTEAD OF LOCALSTORAGE
      if(res.success || this.alert?.toLowerCase().includes('success') || this.alert?.toLowerCase().includes('added')) {
        this.brandService.showToast('success', 'Sales team created successfully!');
        this.router.navigate(['/admin/sales-team']);
      } else {
        this.brandService.showToast('error', this.alert || 'Error creating sales team');
      }
    })
  }

  //---------function for getting searched employee id---------------
  getEmployeeId(value1:any,value2:any){
    this.isShownEmployee=false
    this.data.brand_manager_name=value2
    this.data.brand_manager_id=value1
    console.log("search result",this.data.employee_id)
    this.MgrName="*"
  }

  valuechange4(newValue1: any) {
    console.log("Manager=",newValue1)
    this.data.brand_manager_name=newValue1
    this.Search_employee=""
  }

  valuechangeName(Value: any) {
    this.TeamName="*"
  }

  // 🎯 NEW: Year change handler
  onYearChange() {
    console.log("Year changed to:", this.selectedYear);
    // Reset month selection when year changes
    this.data.month = "";
    this.model = [];
    this.calenderShown = false;
    this.MName = "*";
  }

  SearchEmployee(){
    if(this.data.brand_manager_name!='')
    {
      this.isShownEmployee=true;
    }
    this.searchEmployee=this.data.brand_manager_name
    this.brandService.SearchEmployee(this.searchEmployee).subscribe((res)=>{
      this.employee=res.data
    })
  }

  BrandSelected(value:any){
    this.BName="*"
    console.log("value=",this.Brand[value])
    this.data.brand_id=this.Brand[value].brand_id
    this.data.brand_name=this.Brand[value].brand_name
  }

  // 🎯 UPDATED: Month selection with year support
  MonthSelected(value:any){
    this.model=[];
    this.MName="*";
    
    // Use the selected year instead of current year
    var month=this.Month[value].id
    this.data.month= this.selectedYear + "-" + month  // 🎯 FIX: Use selected year
    
    console.log("Selected month for backend:", this.data.month)

    //---------set max and min for calender-------
    var start=this.Month[value].id+"/"+"1"+"/"+this.selectedYear
    var end=this.Month[value].id+"/"+this.Month[value].last+"/"+this.selectedYear
    console.log("Calendar range:", start, "to", end)
    this.minDate= new Date(start)
    this.maxDate= new Date(end)
    this.calenderShown=true
  }

  SetFinalTeam(){
    this.data.team_mates=[]
    for(var i=0;i<this.selectedItems.length;i++){
      var obj={
        employee_id:this.selectedItems[i].item_id,
        employee_name:this.selectedItems[i].item_text
      }
      this.data.team_mates.push(obj)
    }
  }

  onItemSelect(item: any) {
    console.log(item);
    console.log("one Item selected",this.selectedItems);
    this.TeamMates="*"
  }

  onSelectAll(items: any) {
    console.log(items);
    this.selectedItems=items
    console.log("All Item selected",this.selectedItems);
    this.TeamMates="*"
  }

  onDeSelect(item:any){
    console.log(item);
    console.log("Item De selected",this.selectedItems);
  }

  onDeSelecAll(){
    console.log("hai")
  }

  ngOnInit(): void {
    //-------api for get department name---------
    this.brandService.BrandDropdown().subscribe((res)=>{
      this.Brand=res.data
      console.log("Brand details =",this.Brand)
    })

    this.brandService.ViewAllEmployee().subscribe((res)=>{
      for(var i=0;i<res.data.length;i++){
        this.options.push({ item_id: res.data[i].employee_id, item_text: res.data[i].employee_name});
      }
      console.log("option3=", this.options)
      this.dropdownList= this.options
    })
  }
}